import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';

const ModeContext = createContext();

export const useMode = () => {
  const context = useContext(ModeContext);
  if (!context) {
    throw new Error('useMode must be used within a ModeProvider');
  }
  return context;
};

export const ModeProvider = ({ children }) => {
  const { user } = useAuth();
  const [mode, setMode] = useState('business'); // 'business' or 'homeowner'

  // Load saved mode from localStorage on mount
  useEffect(() => {
    if (user && user.user_type === 'contractor') {
      const savedMode = localStorage.getItem('contractor_mode');
      if (savedMode) {
        setMode(savedMode);
      } else {
        // Default to business mode for contractors
        setMode('business');
      }
    }
  }, [user]);

  // Save mode to localStorage whenever it changes
  useEffect(() => {
    if (user && user.user_type === 'contractor') {
      localStorage.setItem('contractor_mode', mode);
    }
  }, [mode, user]);

  const toggleMode = () => {
    const newMode = mode === 'business' ? 'homeowner' : 'business';
    setMode(newMode);
  };

  const switchToBusinessMode = () => {
    setMode('business');
  };

  const switchToHomeownerMode = () => {
    setMode('homeowner');
  };

  // Only contractors can have dual mode
  const isDualModeEnabled = user && user.user_type === 'contractor';

  const value = {
    mode,
    setMode,
    toggleMode,
    switchToBusinessMode,
    switchToHomeownerMode,
    isDualModeEnabled,
    isBusinessMode: mode === 'business',
    isHomeownerMode: mode === 'homeowner',
  };

  return <ModeContext.Provider value={value}>{children}</ModeContext.Provider>;
};
